import styled from "styled-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { FlexRow, RightFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { ClosableItemColorMarker } from "app/components/compare/StyledComponent";
import { getTooltipHeader } from "app/UtilitiesAndConstants/UtilitiesComponents/chartTooltipHeaderWithMTDSupport";
import ReactDOMServer from "react-dom/server";

const TableCellStyle = styled(RightFlexRow)`
    width: 90px;
    padding: 4px 16px 4px 16px;

    &:nth-child(1) {
        width: 176px;
        justify-content: flex-start;
    }

    &:nth-child(2),
    &:nth-child(3) {
        width: 60px;
        border-right: 1px solid ${colorsPalettes.carbon[50]};
    }

    &:last-child {
        border-right: none;
    }

    .ChangeValue--unsigned {
        float: right;
    }
`;

const TableHeadersStyle = styled(FlexRow)`
    font-size: 12px;
    font-style: normal;
    line-height: 16px;
    font-weight: 400;
    opacity: 0.8;
`;

const TableRowStyle = styled(FlexRow)`
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    letter-spacing: 0.6px;
    line-height: 24px;
`;

const TableCellDomainMarker = styled(ClosableItemColorMarker)<{ background: string }>`
    position: static;
    background-color: ${(p) => p.background};
    margin: 0 8px 0 0;
    flex-shrink: 0;
    width: 10px;
    height: 10px;
`;

const TableCellDomainName = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const TooltipContainer = styled.div`
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
`;

const Title = styled.div`
    ${mixins.setFont({ $size: 16 })};
    font-weight: bold;
    margin-left: 16px;
    margin-bottom: 16px;
`;

export const AdsTrafficTooltip = ({ metricName, points, timeGranularityName, yTooltipFormatter }) => {
    const getHeader = getTooltipHeader(timeGranularityName, points, null);
    const headersList = ["Domain", metricName];
    // sort by x by chronological order
    points.forEach((p) => p.series.data.sort((a, b) => (a.x > b.x ? 1 : -1)));

    const pointsList = points.map((point) => {
        const currentIndex = point.series.data.findIndex((p) => p.category === point.x);
        const prevPointYData = point.series.data[currentIndex - 1]?.y;
        return {
            share: point.point.share,
            traffic: point.point.y,
            color: point.series.color,
            name: point.series.name,
            prevTraffic: prevPointYData || prevPointYData === 0 ? prevPointYData : null,
        };
    });

    const tableHeadersElement = (
        <TableHeadersStyle>
            {headersList.map((header) => (
                <TableCellStyle key={header}>{header}</TableCellStyle>
            ))}
        </TableHeadersStyle>
    );

    const tableRowsElement = pointsList.map((point, index) => (
        <TableRowStyle key={index}>
            <TableCellStyle>
                <TableCellDomainMarker background={point.color} />
                <TableCellDomainName>{point.name}</TableCellDomainName>
            </TableCellStyle>
            <TableCellStyle>{yTooltipFormatter(point.traffic)}</TableCellStyle>
        </TableRowStyle>
    ));

    return ReactDOMServer.renderToString(
        <TooltipContainer>
            <Title>{getHeader}</Title>
            {tableHeadersElement}
            {tableRowsElement}
        </TooltipContainer>,
    );
};
